import React from 'react'

import Text from '../text/Text'
import { ThemeColours, ThemeFontSize, ThemeSpacing } from '../../../types/theme'
import classNames from 'classnames'

import './Badge.scss'

export interface Props {
  className?: string
  colour?: ThemeColours
  size?: ThemeSpacing
  textSize?: ThemeFontSize
  value: string | number
}

function Badge ({ size, colour, value, textSize }: Props) {
  const sizeClass = size ? `size-${size}` : null
  const colourClass = colour ? `colour-${colour}` : null
  return <div className={classNames('badge', sizeClass, colourClass)} >
    <Text size={textSize} bold colour='white'>{value}</Text>
  </div>
}

export default Badge
